import styled from 'styled-components'

const Style = {
	ModalBackground: styled.div`
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100vw;
		height: 100dvh;
		background-color: rgba(0, 0, 0, 0.6);
		z-index: 99999999;
	`,
	Modal: styled.div`
		width: fit-content;
		min-width: 300px;
		height: fit-content;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 24px 20px;
		gap: 16px;
		background-color: ${({theme}) => theme.color.white};
		border-radius: 16px;
	`,
	LogoMobile: styled.img`
		height: 64px;
		width: 64px;
		object-fit: contain;
	`,
	ContainerContent: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 12px;
	`,
	Title: styled.h2`
		${({theme}) => theme.font.large_bold};
		text-align: center;
		color: ${({theme}) => theme.color.black};
		font-size: 16px;
		margin: 0;
	`,
	Content: styled.p`
		${({theme}) => theme.font.small};
		text-align: center;
		color: ${({theme}) => theme.color.grey4};
		font-size: 16px;
		font-weight: 400;
		margin: 0;
		color: #1f2024;
	`,
}
export default Style
